module.exports = __webpack_public_path__ + "img/face-smile-tear.12035fb9.svg";